import styled from 'styled-components';
import colorVariantContainerStyles from '../../styles/colorVariantContainerStyles';

const ColorVariantContainer = styled.div`
    ${colorVariantContainerStyles}
`;

export default ColorVariantContainer;
